import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import Section from './Section';
import { DATA_PRIVACY_ITEMS } from './constants';

type DataPrivacyProps = {};

const DataPrivacy: React.FC<DataPrivacyProps> = () => {
  return (
    <Box id='data-privacy' display='flex' flexDirection='column' my={10}>
      <Typography
        fontSize={{
          xs: '30px',
          sm: '40px',
          md: '57px',
        }}
        fontWeight={600}
        lineHeight={1}
        mb={{
          xs: 3,
        }}
        whiteSpace={{
          xs: 'nowrap',
          md: 'normal',
        }}
      >
        Data Privacy and Security
      </Typography>
      <Box
        display='flex'
        flexDirection='column'
        gap={5}
        mt={{
          xs: 5,
          md: 10,
        }}
      >
        {DATA_PRIVACY_ITEMS.map((item, idx) => (
          <Section key={idx} item={item} />
        ))}
      </Box>
    </Box>
  );
};

export default DataPrivacy;
